import React from 'react'
import { t } from 'ttag'
import { connect } from 'react-redux'
import { getTimer } from 'ducks/timer'
import styles from './ConfirmFinish.module.scss'
import { formatTimeVerbose } from 'utils/stringFormat'
import { BoldButton } from 'components/shared/BoldButton/BoldButton'

import { getGMA, finishGMA, submitGMA } from 'ducks/respondent'

const Content = connect(getTimer)(
  ({ totalAnswers, totalQuestions, secondsLeft }) => {
    return (
      <div className={styles.paragraphs}>
        <div className={styles.paragraph}>
          {t`You have answered ${totalAnswers} of ${totalQuestions} questions`}.
        </div>
        <div className={styles.paragraph}>
          {t`You have `} {formatTimeVerbose(secondsLeft)}
          {t` left`}.
        </div>
      </div>
    )
  },
)

const ConfirmFinish = ({
  finishGMA,
  cancelSubmit,
  totalQuestions,
  totalAnswers,
}) => (
  <div className={styles.background}>
    <div className={styles.container}>
      <div className={styles.title}>{t`Submit?`}</div>
      <Content totalAnswers={totalAnswers} totalQuestions={totalQuestions} />
      <div className={styles.buttons}>
        <BoldButton
          label={t`Yes, I'm done`}
          onClick={() => finishGMA({ reason: 'click button' })}
          isPrimary={false}
        />
        <BoldButton
          label={t`No, take me back`}
          onClick={cancelSubmit}
          isPrimary
        />
      </div>
    </div>
  </div>
)

export default connect(
  getGMA,
  { cancelSubmit: submitGMA, finishGMA },
)(ConfirmFinish)
